
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'index',
        meta: {
            title: '课堂教学智能评价系统',
            type: "pc"
        },
        component: () => import('@/pages/Main.vue')
    },

    {
        path: '/:pathMatch(.*)',
        redirect: '/',
    }

]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior() {
        return { left: 0, top: 0 }
    }
})

export default router;